export default __webpack_public_path__ + "files/BIOE3.pdf";